module.exports = __webpack_public_path__ + "img/toilet-paper-under.ea56da05.svg";